interface ICardImage {
  image: string
}

export const cardImagesList: ICardImage[] = [
  { image: '/static/img/plc1.webp' },
  { image: '/static/img/plc2.webp' },
  { image: '/static/img/plc3.webp' },
  { image: '/static/img/plc4.webp' },
  { image: '/static/img/plc5.webp' },
  { image: '/static/img/plc6.webp' },
  { image: '/static/img/plc7.webp' },
]

function randomDigit() {
  return Math.floor(Math.random() * cardImagesList.length)
}

export const getCardImageUrlByIndex = (index: number): string => {
  index = isNaN(index) ? randomDigit() : index
  const indexShuffle = index % cardImagesList.length
  const imageObj = cardImagesList[indexShuffle]

  return `url(${imageObj?.image})`
}

export const getCardImageSrc = (index: number): string => {
  index = isNaN(index) ? randomDigit() : index
  const indexShuffle = index % cardImagesList.length
  const imageObj = cardImagesList[indexShuffle]

  return imageObj?.image
}

let currentImageIndex = 0

export const getNextCardImageUrl = (): string => {
  const imageObj = cardImagesList[currentImageIndex]
  currentImageIndex = (currentImageIndex + 1) % cardImagesList.length
  return `url(${imageObj?.image})`
}

export const getNextCardImageSrc = (): string => {
  const imageObj = cardImagesList[currentImageIndex]
  currentImageIndex = (currentImageIndex + 1) % cardImagesList.length
  return imageObj?.image
}
